import React from 'react'

export default function TermsANDCondition() {
  return (
    <div className="privacy-policy-container">

  <div className="privacy-hero">

    <span className="badge">Legal</span>

    <h1>Terms & Conditions</h1>

    <p>
      Please read these Terms and Conditions carefully before using MK Shops.
    </p>

    <span className="update-date">
      Effective Date: July 20, 2026
    </span>

  </div>

  <div className="privacy-body">

    <p>
      Welcome to <strong>MK Shops</strong>. By accessing or using our
      website, you agree to comply with these Terms and Conditions.
      If you do not agree with any part of these terms, please do not
      use our platform.
    </p>

    <h2>
      <span className="icon">1</span>
      Acceptance of Terms
    </h2>

    <p>
      By accessing or using MK Shops, you confirm that you have read,
      understood, and agreed to these Terms and Conditions.
    </p>

    <p>
      These terms apply to all visitors, customers, vendors, and anyone
      who accesses the website.
    </p>

    <h2>
      <span className="icon">2</span>
      User Accounts
    </h2>

    <p>
      Customers may browse products without creating an account.
      However, an account is required to submit product reviews.
    </p>

    <ul className="list-check">
      <li>Provide accurate information.</li>
      <li>Verify your email using OTP.</li>
      <li>Keep your account information secure.</li>
      <li>You are responsible for all activities under your account.</li>
    </ul>

    <h2>
      <span className="icon">3</span>
      Vendor Accounts
    </h2>

    <p>
      Vendors can create their own stores on MK Shops.
    </p>

    <ul className="list-check">
      <li>Shop Name is required.</li>
      <li>Email Address is required.</li>
      <li>Shop Description is optional.</li>
      <li>Phone Number is optional.</li>
      <li>Shop Address is optional.</li>
    </ul>

    <p>
      Vendors are responsible for all information and products published
      in their stores.
    </p>
        <h2>
      <span className="icon">4</span>
      Customer Responsibilities
    </h2>

    <p>
      Customers are expected to use MK Shops responsibly and respectfully.
    </p>

    <ul className="list-check">
      <li>Provide accurate information when required.</li>
      <li>Respect vendors and other users.</li>
      <li>Avoid submitting false or misleading reviews.</li>
      <li>Do not attempt to access unauthorized areas of the website.</li>
      <li>Comply with all applicable laws while using the platform.</li>
    </ul>

    <h2>
      <span className="icon">5</span>
      Product Listings
    </h2>

    <p>
      Product listings on MK Shops are created and managed by individual
      vendors.
    </p>

    <p>
      Vendors are responsible for ensuring that product information,
      descriptions, pricing, and images are accurate and comply with
      applicable laws.
    </p>

    <p>
      MK Shops reserves the right to edit, suspend, or remove any product
      listing that violates these Terms and Conditions.
    </p>

    <h2>
      <span className="icon">6</span>
      Orders and Payments
    </h2>

    <p>
      Orders placed through MK Shops are processed by the respective vendors.
    </p>

    <ul className="list-check">
      <li>Customers should review product details before placing an order.</li>
      <li>Prices are determined by individual vendors.</li>
      <li>Orders may be cancelled if fraudulent activity is detected.</li>
      <li>Payment methods may change as new payment services become available.</li>
    </ul>

    <div className="highlight-box">
      <p>
        MK Shops is a marketplace platform and does not guarantee the
        availability of every listed product or service.
      </p>
    </div>

    <h2>
      <span className="icon">7</span>
      Reviews and Ratings
    </h2>

    <p>
      Customers who have registered an account may submit reviews for
      products available on MK Shops.
    </p>

    <ul className="list-check">
      <li>Reviews must be honest and based on actual experiences.</li>
      <li>Spam, abusive language, or misleading reviews are prohibited.</li>
      <li>MK Shops reserves the right to remove reviews that violate our policies.</li>
    </ul>

    <p>
      Vendor ratings and verification badges may change over time based on
      customer feedback, profile completion, and platform policies.
    </p>

    <h2>
      <span className="icon">8</span>
      Intellectual Property
    </h2>

    <p>
      The MK Shops name, logo, website design, software, and other original
      content are the intellectual property of MK Shops unless otherwise stated.
    </p>

    <p>
      Users and vendors may not copy, reproduce, distribute, or modify any
      part of the platform without prior written permission.
    </p>


    <h2>
  <span className="icon">9</span>
  Prohibited Activities
</h2>

<p>
  To maintain a safe and trustworthy marketplace, users and vendors agree not
  to engage in any of the following activities:
</p>

<ul className="list-check">
  <li>Providing false or misleading information.</li>
  <li>Uploading illegal, harmful, or prohibited products.</li>
  <li>Posting abusive, offensive, or defamatory content.</li>
  <li>Attempting to hack, disrupt, or damage the website.</li>
  <li>Violating the rights or privacy of other users.</li>
  <li>Using automated tools or bots without permission.</li>
</ul>

<h2>
  <span className="icon">10</span>
  Account Suspension and Termination
</h2>

<p>
  MK Shops reserves the right to suspend or permanently terminate any account
  that violates these Terms and Conditions or engages in activities that may
  harm the platform or its users.
</p>

<p>
  We may remove products, reviews, or vendor stores that violate our policies
  without prior notice.
</p>

<div className="highlight-box">
  <p>
    Repeated violations may result in the permanent suspension of customer or
    vendor accounts.
  </p>
</div>

<h2>
  <span className="icon">11</span>
  Limitation of Liability
</h2>

<p>
  MK Shops provides a platform that connects customers and independent vendors.
  While we strive to maintain a secure and reliable marketplace, we are not
  responsible for vendor actions, product quality, shipping delays, or disputes
  between buyers and sellers.
</p>

<p>
  To the fullest extent permitted by law, MK Shops shall not be liable for any
  indirect, incidental, special, or consequential damages resulting from the
  use of the platform.
</p>

<h2>
  <span className="icon">12</span>
  Changes to These Terms
</h2>

<p>
  MK Shops may update these Terms and Conditions at any time to reflect changes
  in our services, legal requirements, or business practices.
</p>

<p>
  Updated terms will be published on this page along with the revised
  Effective Date.
</p>

<h2>
  <span className="icon">13</span>
  Contact Us
</h2>

<p>
  If you have any questions about these Terms and Conditions, please contact
  us using the information below.
</p>

<div className="contact-box">

  <div className="contact-item">
    <span className="label">Website</span>
    <span className="value">MK Shops</span>
  </div>

  <div className="contact-item">
    <span className="label">Email</span>
    <span className="value">
      <a href="mailto:mktorushops@gmail.com">
        mktorushops@gmail.com
      </a>
    </span>
  </div>

  <div className="contact-item">
    <span className="label">Support</span>
    <span className="value">
      Our support team will respond as soon as possible.
    </span>
  </div>

</div>
    </div>
    
    </div>
  )
}
